import React from "react";
import { ProjectListEntry } from "../core/types";
import { translate } from "../core/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteProjectButton } from "./DeleteProjectButton";

interface ProjectListTableProps {
  projects: ProjectListEntry[];
  onProjectClick: (project: ProjectListEntry) => void;
  onProjectDeleted?: () => void;
  listType?: "full" | "compact";
  newProjectAvailable?: boolean;
  projectsShown?: number;
}

// Icon strings
const ICONS = {
  quest: "map-marker-alt",
  directory: "folder",
  public: "globe",
  private: "lock",
};

// Mocked project for new app creation
const NEW_PROJECT: ProjectListEntry = {
  id: "NEW",
  name: "New App",
  status: "new",
};

export const ProjectListTable: React.FC<ProjectListTableProps> = ({ 
  projects, 
  onProjectClick,
  onProjectDeleted,
  listType = "full",
  newProjectAvailable = true,
  projectsShown = undefined
}) => {
  // Helper function to decode the project name
  const decodeName = (name: string) => decodeURIComponent(name);

  // Helper function to get the type text and icon based on status
  const getTypeAndIcon = (status: string | undefined) => {
    switch (status) {
      case "quest":
        return { icon: ICONS.quest, text: translate("Quest") };
      case "directory":
        return { icon: ICONS.directory, text: translate("Ordner") };
      case "public":
        return { icon: ICONS.public, text: translate("Projekt") };
      case "private":
      default:
        return { icon: ICONS.private, text: translate("Projekt") };
    }
  };

  // Sort projects by name (case-insensitive)
  const sortedProjects = [...projects].sort((a, b) => 
    decodeName(a.name).localeCompare(decodeName(b.name), undefined, { sensitivity: 'base' })
  );

  // Apply projectsShown limit if specified
  const displayedProjects = projectsShown ? sortedProjects.slice(0, projectsShown) : sortedProjects;

  console.log("listType: " + listType);
  return (
    <>
      {newProjectAvailable && (
        <div className="d-flex justify-content-end mb-2">
          <button onClick={() => onProjectClick(NEW_PROJECT)} className="btn btn-sm btn-primary">
            <FontAwesomeIcon icon="plus" /> {translate("Code-Space erstellen")}
          </button>
        </div>
      )}
      <table className="table">
        {(listType === "full") && (
          <thead>
            <tr>
              <th></th>
              {false && <th>{translate("App-Code")}</th>}
              <th className="text-start">{translate("code-space-name")}</th>
              {listType === "full" && <th>{translate("Art")}</th>}
              <th></th>
            </tr>
          </thead>
        )}
        <tbody>
          {displayedProjects.map((project) => {
            if (project.status === "new") return null;
            
            const { icon, text } = getTypeAndIcon(project.status);
            const name = decodeName(project.name);
            // Show delete button only for real projects (not quest, directory, etc.)
            // Treat projects without status as "private" (default)
            const isRealProject = project.status === "private" || 
                                 project.status === "public" || 
                                 !project.status;
            
            return (
              <tr 
                key={project.id} 
                onClick={() => onProjectClick(project)} 
                className="project-list-row"
                style={{ cursor: "pointer" }}
              >
                <td>
                  <img src={project.icon} alt={name} style={{ width: '24px', height: '24px' }} />
                </td>
                {false && <td>{project.id}</td>}
                <td className="text-start">{name}</td>
                {listType === "full" && (
                  <td>
                    <FontAwesomeIcon icon={icon as any} /> {text}
                  </td>
                )}
                <td onClick={(e) => e.stopPropagation()}>
                  {isRealProject && (
                    <DeleteProjectButton 
                      projectId={project.id} 
                      projectName={project.name}
                      className="btn-sm"
                      onDeleted={onProjectDeleted}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
